<div style="width: 100%;">
  <mat-card class="box">
      <div class="divtitle">
        <span class="flex-container" style="padding: 8px;">
          <h1 class="label">{{'workers.label' | transloco}}</h1>
          <div>  
            <button mat-raised-button color="primary" routerLink="/import" style="margin-right: 7px;" >{{'workers.import' | transloco}}</button>  
            <button mat-raised-button color="primary" routerLink="/worker" >{{'workers.new' | transloco}}</button>
          </div>
        </span>
      </div>
  </mat-card>
</div>

<div style="width: 100%;">
  <mat-card class="box">
    <div>

      <div class="formBox">
        <form method="post" class="wrapper" >
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortActive="id" >
            <!-- ID Column -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >ID.</th>
              <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <!-- first_name Column -->
            <ng-container matColumnDef="first_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'workers.name' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.first_name}} </td>
            </ng-container>

            <!-- last_name Column -->
            <ng-container matColumnDef="last_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'workers.surname' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.last_name}} </td>
            </ng-container>

            <!-- company_id Column -->
            <ng-container matColumnDef="company_id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'workers.company' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.company_id}} </td>
            </ng-container>

            <!-- dni Column -->
            <ng-container matColumnDef="dni">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'workers.dni' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.dni}} </td>
            </ng-container>

            <!-- device Column (solo superadmin) -->
            <ng-container matColumnDef="device">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'workers.device' | transloco}}</th>
              <td mat-cell *matCellDef="let element">
                <a *ngIf="element.device_id"
                   [routerLink]="['/device']"
                   [queryParams]="{id: element.device_id, companyId: element.device_company_id}"
                   (click)="$event.stopPropagation()">
                  {{element.device_serial_number}}
                </a>
                <span *ngIf="!element.device_id">-</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="storageService.roleId===1 ? displayedColumns2 : displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: storageService.roleId===1 ? displayedColumns2 : displayedColumns; let j =index;"
            (click)="onRowClicked(row); $event.stopPropagation()" tabindex="0" (keydown.enter)="onRowClicked(row)"
            [ngClass]="{'row1':j%2 === 0 , 'row2':j%2 != 0 }"> </tr>

          </table>
          
          <div class="divPag">
            <mat-paginator [pageSizeOptions]="[9, 10, 20, 50]"
                            showFirstLastButtons
                            aria-label="Select page">
            </mat-paginator>
          </div> 
        </form>
      </div>

  </div>
  </mat-card>
</div>

<div>
  <mat-card *ngIf="isLoading" class="center-loading">
    <mat-card-content style="margin: 20%;" >
      <mat-progress-spinner style="margin: 0 auto;" color="primary" mode='indeterminate'value='50'></mat-progress-spinner>
    </mat-card-content>
  </mat-card>
</div>
